import React from "react";
import UcitajDokumentRjesenja from "../UcitajDokumentRjesenja/UcitajDokumentRjesenja";
import OdaberiStatusRjesenja from "../OdaberiStatusRjesenja/OdaberiStatusRjesenja";

const IzlazniDokument = ({
  uploadHandler,
  selectedFiles,
  statuses,
  handleRadioButton,
  selectedStatus,
  submitUploadedDocument,
  current,
}) => {
  return (
    <>
      {current == 1 && (
        <UcitajDokumentRjesenja
          uploadHandler={uploadHandler}
          selectedFiles={selectedFiles}
        />
      )}
      {current == 2 && (
        <>
          <OdaberiStatusRjesenja
            statuses={statuses}
            handleRadioButton={handleRadioButton}
            selectedStatus={selectedStatus}
            submitUploadedDocument={submitUploadedDocument}
          />
        </>
      )}
    </>
  );
};

export default IzlazniDokument;
